import { LoaderCircle } from 'lucide-react'

import { formatearEtiquetaPeriodo, formatearPorcentaje } from '../../../utils/analiticaPos'
import { formatearFechaPos, formatearKilosPos, formatearMontoPos } from '../../../utils/pos'
import { GraficoBarrasVerticales, GraficoRankingHorizontal } from './GraficoBarras'

// Panel de drill-down compartido: evolución en el tiempo + ranking de
// contrapartes (clientes de un producto, o productos de un cliente).
// `modo`: 'producto' | 'cliente'.
function DetalleSeleccion({ modo, titulo, cargando, tendencia, contrapartes }) {
  if (cargando) {
    return (
      <div className="flex min-h-40 items-center justify-center rounded-2xl border border-slate-200 bg-white shadow-sm">
        <LoaderCircle size={28} className="animate-spin text-emerald-600" />
      </div>
    )
  }

  const granularidad = tendencia?.[0]?.granularidad

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-4 text-base font-bold text-slate-900">
          Evolución de {titulo}
        </h3>

        {tendencia && tendencia.length > 0 ? (
          <GraficoBarrasVerticales
            datos={tendencia.map((t) => ({
              etiqueta: formatearEtiquetaPeriodo(t.periodo, granularidad),
              valor: t.monto_vendido,
            }))}
            formatearValor={formatearMontoPos}
          />
        ) : (
          <p className="py-8 text-center text-sm text-slate-400">Sin datos.</p>
        )}
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-4 text-base font-bold text-slate-900">
          {modo === 'producto' ? 'Principales clientes' : 'Principales productos'}
        </h3>

        {contrapartes && contrapartes.length > 0 ? (
          <>
            <GraficoRankingHorizontal
              datos={contrapartes.slice(0, 10).map((c) => ({
                etiqueta: modo === 'producto' ? c.razon_social : c.producto_nombre,
                valor: c.monto,
                subetiqueta: `${formatearKilosPos(c.kilos)} · ${formatearMontoPos(c.precio_promedio_kg)}/kg · ${formatearPorcentaje(c.participacion_pct)}`,
              }))}
              formatearValor={formatearMontoPos}
              color="bg-sky-500"
            />

            {modo === 'cliente' && (
              <div className="mt-4 border-t border-slate-100 pt-3 text-xs text-slate-400">
                {contrapartes.slice(0, 10).map((c) => (
                  <p key={c.producto_id}>
                    {c.producto_nombre}: última compra {formatearFechaPos(c.ultima_compra)}
                  </p>
                ))}
              </div>
            )}
          </>
        ) : (
          <p className="py-8 text-center text-sm text-slate-400">Sin datos.</p>
        )}
      </div>
    </div>
  )
}

export default DetalleSeleccion
